import {queries} from '@/shared/integrations/zero'
import {useQuery, useSuspenseQuery} from '@rocicorp/zero/react'

export function useGetAllProductionLocations() {
  return useQuery(queries.pharmacies.getAllProductionLocations())
}

export function useSuspenseGetAllProductionLocations() {
  return useSuspenseQuery(queries.pharmacies.getAllProductionLocations())
}
